/**
 * Application-wide constants
 * 
 * Centralized constants to avoid magic numbers throughout the codebase
 */

/**
 * Animation and timing constants (in milliseconds)
 */
export const TIMING = {
  /** Animation duration for background transitions */
  ANIMATION_DURATION: 400,
  
  /** Delay for PayPal button rendering */
  PAYPAL_RENDER_DELAY: 100,
  
  /** Delay for DOM ready checks */
  DOM_READY_DELAY: 100,
  
  /** Delay for accordion opening animations */
  ACCORDION_OPEN_DELAY: 500,
  
  /** Delay for view initialization */
  VIEW_INIT_DELAY: 1000,
  
  /** Delay for purchase flow */
  PURCHASE_FLOW_DELAY: 150,
  
  /** Delay for PDF rendering */
  PDF_RENDER_DELAY: 100,
  
  /** Delay for PDF page transitions */
  PDF_PAGE_TRANSITION: 400,
  
  /** Delay for PDF operations */
  PDF_OPERATION_DELAY: 300,
  
  /** Delay for invitation processing */
  INVITATION_PROCESSING_DELAY: 500,
  
  /** Badge update debounce time */
  BADGE_UPDATE_DEBOUNCE: 300
} as const;

/**
 * File size constants (in bytes)
 */
export const FILE_SIZE = {
  /** Maximum logo file size (5MB) */
  MAX_LOGO_SIZE: 5 * 1024 * 1024,
  
  /** Maximum file size for uploads */
  MAX_UPLOAD_SIZE: 10 * 1024 * 1024
} as const;

/**
 * Cache duration constants (in milliseconds)
 */
export const CACHE_DURATION = {
  /** Status cache duration (30 seconds) */
  STATUS: 30000,
  
  /** Credits cache duration (10 seconds) */
  CREDITS: 10000,
  
  /** TAT user data cache duration (60 seconds) */
  TAT_USER_DATA: 60000,
  
  /** Home page data refresh interval (30 seconds) */
  HOME_DATA_REFRESH: 30000,

  /** Background sync interval for status data: user, company, jobs, tools (60 seconds) */
  BACKGROUND_SYNC: 60000,

  /** Results (getAllTatUserData) are refreshed in the background only when older than this (5 minutes) */
  RESULTS_REFRESH: 5 * 60 * 1000,

  /** Minimum gap between refreshes triggered by app resume or going online (15 seconds) */
  RESUME_REFRESH_MIN_GAP: 15000
} as const;

/**
 * Invitation constants
 */
export const INVITATIONS = {
  /** Days until an unredeemed invitation is released on the server (event evt_release_stale_invitation_credits) */
  VALIDITY_DAYS: 14
} as const;

/**
 * Credits overview constants
 */
export const CREDITS = {
  /** Job search in the overview from this number of jobs (in the selected tool) */
  SEARCH_MIN_JOBS: 10
} as const;
